import Login from './Login.svelte'
import type { AppContext } from 'types/common'
import sessionStore, { getSession } from 'stores/session'
import { graphql, CloseSessionMutationStore } from '$houdini'
import { endOAuthSession } from 'utility/oauth-helper'

const serverInformationQuery = graphql(`
	query ServerInformation {
		serverInformation {
			schemaVersion
			releaseVersionNumber
		}
	}
`)

const storesForLoginQuery = graphql(`
	query StoresForLogin {
		storesForLogin {
			id
			code
			name
		}
	}
`)

// Defined in Login.svelte; operation names must be unique, so reuse its generated store
const closeSessionMutation = new CloseSessionMutationStore()

export default function ({ stateRouter }: AppContext) {
	stateRouter.addState({
		name: 'login',
		route: 'login',
		querystringParameters: [],
		template: {
			svelte: true, // this tells our renderer wrapper that this is a svelte component
			component: Login, // this is the svelte component
			options: {
				// these are the options passed to the svelte component
			},
		},
		async resolve(_data, _parameters) {
			const oldSession = getSession()

			if (oldSession?.authToken) {
				try {
					if (oldSession.authToken === 'bff-cookie') {
						await endOAuthSession()
					} else {
						//Do NOT clear out the session before this API call, or it will fail
						await closeSessionMutation.mutate(null)
					}
				} catch (e) {
					console.error('Failed to close session', e)
				}
			}
			//Alright, it's safe to clear the session out now
			sessionStore.set({})
			const lastUsername = localStorage.getItem('lastUsername')

			async function loadStores() {
				const { data } = await storesForLoginQuery.fetch()
				return data?.storesForLogin ?? []
			}

			async function loadServerInformation() {
				const { data } = await serverInformationQuery.fetch()

				return data?.serverInformation ?? { schemaVersion: 'unknown', releaseVersionNumber: 'unknown' }
			}

			const res = {
				loadStores: loadStores(),
				username: lastUsername ?? '',
				isLoading: false,
				serverInformation: loadServerInformation(),
			}

			return res
		},
	})
}
